<!--
 * @Author: your name
 * @Date: 2021-09-27 17:48:35
<<<<<<< HEAD
<<<<<<< HEAD
 * @LastEditTime: 2022-11-22 10:41:15
=======
 * @LastEditTime: 2022-11-22 15:46:29
>>>>>>> feat-m-stockAndLogistics-20221122
=======
 * @LastEditTime: 2022-11-22 17:32:03
>>>>>>> feat-m-stockAndLogistics-20221122
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\strategy\logistics\orderMoney\components\DataForm.vue
-->
<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="150px"
    width="650px"
    class="view-container"
    @handleConfirm="handleConfirm"
  >
    <BjDivider>{{ $t('settingAuthorize.addAndEdit.authorized') }}</BjDivider>
    <el-col :span="span">
      <el-form-item :label="$t('settingAuthorize.addAndEdit.logistics')" prop="logisticsCompanyId">
        <BjSelectLogisticCompany
          v-model="form.logisticsCompanyId"
          :default-options="{
            label: form.logisticsCompanyName,
            value: form.logisticsCompanyId,
          }"
          @change="onLogistic"
        />
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingAuthorize.addAndEdit.business')" prop="logisticsBusinessId">
        <BjSelectLogisticBusiness
          v-model="form.logisticsBusinessId"
          :disabled="!form.logisticsCompanyId"
          :default-params="defaultParams"
          :default-options="{
            label: form.logisticsBusinessName,
            value: form.logisticsBusinessId,
          }"
          :placeholder="form.logisticsCompanyId ? $t('chooseText') : $t('settingAuthorize.addAndEdit.logisticsText')"
          @change="onBusiness"
        />
      </el-form-item>
    </el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingAuthorize.addAndEdit.interface')" prop="interfaceType">
        <BjSelectLov v-model="form.interfaceType" lov-code="STHI.INTERFACE_TYPE" />
      </el-form-item>
    </el-col>

    <el-col :span="span">
      <el-form-item :label="$t('settingAuthorize.addAndEdit.channel')" prop="channelList">
        <BjSelectLov
          v-model="form.channelList"
          multiple
          lov-code="SCHL.CHANNEL_TYPE"
          @change="onChannelList"
        /> </el-form-item
    ></el-col>
    <el-col :span="span">
      <el-form-item :label="$t('settingAuthorize.addAndEdit.authorizeTitle')" prop="shopId">
        <BjSelectStoreOnline
          v-model="form.shopId"
          :default-params="{ status: true, authStatus: 2 }"
        /> </el-form-item
    ></el-col>
    <el-col :span="22">
      <el-form-item>
        <el-checkbox v-model="form.defaultFlag"
          ><el-tooltip
            effect="dark"
            placement="top-start"
            :content="$t('settingAuthorize.addAndEdit.tooltipText')"
          >
            <i class="el-icon-question"></i> </el-tooltip
          >
          {{ $t('settingAuthorize.addAndEdit.defaultType') }}</el-checkbox
        >
        <el-checkbox v-model="form.autoGetLogisticsNo">{{ $t('settingAuthorize.addAndEdit.shipment') }}</el-checkbox>
      </el-form-item></el-col
    >
    <template>
      <BjDivider>
        {{ $t('settingAuthorize.addAndEdit.useWarehouse') }}
        <template #right>
          <el-button type="primary" @click="onAddStore">{{ $t('settingAuthorize.addAndEdit.addWarehouse') }}</el-button>
        </template>
      </BjDivider>
      <el-table :data="form.warehouseList" script border>
        <el-table-column type="index" :label="$t('table.countText')" align="center" width="60" />
        <el-table-column prop="warehouseCode" :label="$t('settingAuthorize.addAndEdit.table.warehouseCode')" align="center" />
        <el-table-column prop="warehouseName" :label="$t('settingAuthorize.addAndEdit.table.warehouseName')" align="center" />
      </el-table>
    </template>
    <template v-if="isShowTableEndPrintData">
      <BjDivider>{{ $t('settingAuthorize.addAndEdit.interfaceMsg') }} </BjDivider>
      <el-table :data="tableData" script border>
        <!-- <el-table-column type="index" width="50" label="序号" /> -->
        <el-table-column prop="branchCode" :label="$t('settingAuthorize.addAndEdit.table.code')" align="center" />
        <el-table-column prop="branchName" :label="$t('settingAuthorize.addAndEdit.table.name')" align="center" />
        <el-table-column prop="monthlyCardNumber" :label="$t('settingAuthorize.addAndEdit.table.cardNumber')" align="center" />
        <el-table-column prop="deliveryAddress" :label="$t('settingAuthorize.addAndEdit.table.address')" align="center" />
        <el-table-column prop="quantity" :label="$t('settingAuthorize.addAndEdit.table.electronicForm')" align="center" />
        <el-table-column prop="defaultAddress" :label="$t('settingAuthorize.addAndEdit.table.defaultAddress')" align="center" />
        <el-table-column prop="serviceBusiness" :label="$t('settingAuthorize.addAndEdit.table.business')" align="center" />
      </el-table>
      <BjDivider
        >{{ $t('settingAuthorize.addAndEdit.print') }}
        <template #right>
          <el-button type="text" @click="onDownload">{{ $t('settingAuthorize.addAndEdit.downloadPrint') }}</el-button>
        </template>
      </BjDivider>
      <el-col :span="span">
        <el-form-item :label="$t('settingAuthorize.addAndEdit.standardTemplate')" prop="printCloudStandardTemplateName">
          <BjSelectLov
            v-model="form.printCloudStandardTemplateName"
            :option-list="standardTemplateOptions"
            item-value="name"
            :loading="templateLoading"
            @change="changeStandardTemplate"
          />
        </el-form-item>
      </el-col>
      <el-col :span="span">
        <el-form-item :label="$t('settingAuthorize.addAndEdit.printTemplate')" prop="printCloudDefTemplateName">
          <BjSelectLov
            v-model="form.printCloudDefTemplateName"
            :option-list="defTemplateOptions"
            item-value="name"
            :disabled="!form.printCloudStandardTemplateName"
            :loading="templateLoading"
            @change="changeDefTemplate"
          />
        </el-form-item>
      </el-col>
      <el-col :span="span">
        <el-form-item :label="$t('settingAuthorize.addAndEdit.sender')" prop="sender">
          <BjInput
            v-model="form.sender"
            :maxlength="MAX_LENGTH.DEFAULT"
            :placeholder="$t('inputText')"
            clearable
          />
        </el-form-item>
      </el-col>
      <el-col :span="span">
        <BjFormItemMobile
          v-model="form.senderPhone"
          :label="$t('settingAuthorize.addAndEdit.sendMobile')"
          prop="senderPhone"
          :required="true"
        />
      </el-col>
      <el-col :span="22">
        <el-form-item :label="$t('settingAuthorize.addAndEdit.sendAddress')" prop="fullAddress" style="margin-bottom: 0">
          <el-col :span="11">
            <BjRegionCascader
              v-model="regionList"
              class="full-width"
              is-array
              clearable
              @change="onChangeRegionCascader"
            />
          </el-col>
          <el-col :span="13">
            <BjInput
              v-model="form.address"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('settingAuthorize.addAndEdit.address')"
              clearable
            />
          </el-col>
        </el-form-item>
      </el-col>
      <el-col :span="22">
        <el-form-item
          ><span class="red" style="font-size:12px;"
            >{{ $t('settingAuthorize.addAndEdit.tips') }}</span
          ></el-form-item
        >
      </el-col>
    </template>
    <!-- 弹窗组件：适用仓库 -->
    <BjDialogList
      ref="warehouse"
      multiple
      row-keys="code"
      :config="$BjDialogListConfig.stockWarehouseLogic()"
      @confirm="onConfirmWarehouseList"
    />
  </BjDrawerForm>
</template>
<script>
import { thirdApi } from '@/api';
import BjRegionCascader from '@/components/BjRegionCascader';
import { isArray } from '@/utils/validate';
const getDefaultForm = () => {
  return {
    address: null,
    autoGetLogisticsNo: false,
    channelList: [
      // {
      //   channelTypeCode: null,
      //   channelTypeCodeMeaning: null,
      //   logisticsAuthorizeId: 0,
      // },
    ],
    city: null,
    cityCode: null,
    defaultFlag: false,
    district: null,
    districtCode: null,
    id: null,
    interfaceType: null,
    interfaceTypeMeaning: null,
    logisticsBusinessCode: null,
    logisticsBusinessId: null,
    logisticsBusinessName: null,
    logisticsCompanyCode: null,
    logisticsCompanyId: null,
    logisticsCompanyName: null,
    objectVersionNumber: null,
    printCloudDefTemplate: null,
    printCloudStandardTemplate: null,
    province: null,
    provinceCode: null,
    sender: null,
    senderPhone: null,
    shopId: null,
    shopName: null,
    warehouseList: [],

    printCloudStandardTemplateName: null,
    printCloudDefTemplateName: null,
  };
};
export default {
  components: { BjRegionCascader },
  data() {
    return {
      span: 11,
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验

      tableData: [],
      regionList: [],
      standardTemplateOptions: [],
      defTemplateOptions: [],
      channelList: [], // form.channelList的映射
      templateLoading: false,
    };
  },
  computed: {
    defaultParams() {
      // 以 所属物流商 为默认参数
      return { companyId: this.form.logisticsCompanyId, enableFlag: true };
    },
    isShowTableEndPrintData() {
      const { logisticsBusinessId, interfaceType, shopId } = this.form;
      const flag = !!(logisticsBusinessId && interfaceType && shopId);
      if (flag) this.getData();
      return flag;
    },
    rules() {
      const validateFullAddress = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!this.form.provinceCode || !this.form.cityCode || !this.form.districtCode) {
            // 请选择省/市/区
            callback(new Error(this.$t('settingAuthorize.addAndEdit.rulesCallback1')));
          }
          if (!this.form.address) {
            // 请输入详细地址
            callback(new Error(this.$t('settingAuthorize.addAndEdit.rulesCallback2')));
          }
          callback();
        });
      };
      return {
        logisticsCompanyId: [{ required: true, message: this.$t('settingAuthorize.addAndEdit.rulesLogisticsCompany'), trigger: 'change' }],
        logisticsBusinessId: [{ required: true, message: this.$t('settingAuthorize.addAndEdit.rulesLogisticsBusiness'), trigger: 'change' }],
        interfaceType: [{ required: true, message: this.$t('settingAuthorize.addAndEdit.rulesInterfaceType'), trigger: 'change' }],
        channelList: [{ required: true, message: this.$t('settingAuthorize.addAndEdit.rulesChannelList'), trigger: 'change' }],
        shopId: [{ required: true, message: this.$t('settingAuthorize.addAndEdit.rulesShop'), trigger: 'change' }],
        printCloudStandardTemplateName: [
          { required: true, message: this.$t('settingAuthorize.addAndEdit.selectStandardTemplate'), trigger: 'change' },
        ],
        sender: [{ required: true, message: this.$t('settingAuthorize.addAndEdit.rulesSender'), trigger: 'blur' }],
        senderPhone: [{ required: true, message: this.$t('settingAuthorize.addAndEdit.rulesSendMobile'), trigger: 'blur' }],
        fullAddress: {
          required: true,
          validator: validateFullAddress,
          trigger: 'change',
        },
      };
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.tableData = [];
      this.regionList = [];
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.$t('settingAuthorize.authorized'));
      this.form = Object.assign(getDefaultForm(), info || {});
      // 回显相关处理逻辑
      if (this.isEdit) {
        this.channelList = info.channelList;
        this.form.printCloudStandardTemplateName = info.printCloudStandardTemplate?.name;
        // 是否存在 标准模板，存在获取 自定义模板
        if (this.form.printCloudStandardTemplateName) {
          const stdTemplateData = JSON.parse(info.printCloudStandardTemplate.data);
          const { interfaceType, shopId } = this.form;
          this.getLogisticsAuthorizesCustomares({
            shopId,
            stdTemplateData,
            interfaceType,
          });
        }
        this.form.printCloudDefTemplateName = info.printCloudDefTemplate?.name;
        this.form.channelList = info.channelList.map(e => e.channelTypeCode);
        // 面单寄件地址回显相关
        this.regionList = [
          Number(info.provinceCode),
          Number(info.cityCode),
          Number(info.districtCode),
        ];
        this.getData();
      }
    },
    onLogistic(val, data = {}) {
      this.form.logisticsCompanyCode = data.code;
      this.form.logisticsCompanyName = data.name;

      this.form.logisticsBusinessId = null;
      this.form.logisticsBusinessCode = null;
      this.form.logisticsBusinessName = null;
    },
    onBusiness(val, data = {}) {
      this.form.logisticsBusinessCode = data.code;
      this.form.logisticsBusinessName = data.name;
    },
    onChannelList(v, item) {
      this.channelList = item.map(e => {
        return {
          channelTypeCode: e.value,
          channelTypeCodeMeaning: e.label,
        };
      });
    },
    /** 添加仓库 */
    onAddStore() {
      this.$refs.warehouse.show(
        this.form.warehouseList.map(item => {
          return {
            id: item.warehouseId,
            code: item.warehouseCode,
            name: item.warehouseName,
          };
        }),
      );
    },
    onConfirmWarehouseList(data) {
      this.form.warehouseList = data.map(item => {
        return {
          warehouseCode: item.code,
          warehouseId: item.id,
          warehouseName: item.name,
        };
      });
    },
    onChangeRegionCascader(v) {
      this.form.province = v[0].label;
      this.form.city = v[1].label;
      this.form.district = v[2].label;

      this.form.provinceCode = v[0].value;
      this.form.cityCode = v[1].value;
      this.form.districtCode = v[2].value;
    },
    /* *下载打印组件 */
    onDownload() {
      // 拼多多打印组件下载地址
      window.location.href =
        'http://meta.pinduoduo.com/api/one/app/v1/lateststable?appId=com.xunmeng.pddprint&platform=windows&subType=main';
    },
    /* 选择云打印标准模板相关 */
    changeStandardTemplate(v, item) {
      const { data, name } = item;
      this.form.printCloudStandardTemplate = { data, name };
      const stdTemplateData = JSON.parse(data);
      const { interfaceType, shopId } = this.form;
      // 自定义模板数据清空
      this.form.printCloudDefTemplateName = null;
      this.form.printCloudDefTemplate = null;
      // 获取自定义模板
      this.getLogisticsAuthorizesCustomares({
        shopId,
        stdTemplateData,
        interfaceType,
      });
    },
    /** 云打印自定义模板相关 */
    changeDefTemplate(v, item) {
      const { data, name } = item;
      this.form.printCloudDefTemplate = { data, name };
    },
    handleConfirm() {
      if (this.form.warehouseList.length === 0) {
        // 请选择使用仓库
        this.msgError(this.$t('settingAuthorize.addAndEdit.msgError'));
        return;
      }
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) API_DATA['_innerMap'] = {};
      API_DATA.channelList = this.channelList;
      const API = (this.isEdit ? 'put' : 'add') + 'LogisticsAuthorizes';
      this.saveApi(API, API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },
    saveApi(API, API_DATA) {
      thirdApi[API](API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    async getData() {
      const { logisticsBusinessId, interfaceType, shopId } = this.form;
      const obj = { logisticsBusinessId, interfaceType, shopId };
      if (interfaceType && shopId && logisticsBusinessId) {
        // 获取接口信息table数据
        thirdApi.getLogisticsAuthorizesinterfaceInfo(obj).then(res => {
          if (isArray(res)) this.tableData = res;
        });
        // 获取云打印标准模板下拉数据
        this.templateLoading = true;
        const res = await thirdApi.getLogisticsAuthorizesStdTemplate(obj);
        this.templateLoading = false;
        if (isArray(res)) {
          this.standardTemplateOptions = res.map(item => {
            return {
              ...item,
              label: item.name,
              value: item.data,
            };
          });
        }
      }
    },
    /** 获取云打印自定义模板 */
    getLogisticsAuthorizesCustomares(API_DATA) {
      this.templateLoading = true;
      thirdApi.getLogisticsAuthorizesCustomares(API_DATA).then(res => {
        if (isArray(res)) {
          this.defTemplateOptions = res.map(item => {
            return {
              ...item,
              label: item.name,
              value: item.data,
            };
          });
        }
        this.templateLoading = false;
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
